import React, { useLayoutEffect } from "react";
import { AttachmentArchivesItem } from "./AttachmentArchivesItem";
import './AttachmentStyle.css';
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import Loader from '../../../common/Loader';
import { getValueFromResource } from "../../../common/timeLiveFunction";

export const AttachmentArchives = () => {
    const { t } = useTranslation();
    const { isLoading } = useAppSelector((state) => state.attachment);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const ModuleArray : any = [
        { value: '-1', label: 'Timesheet' },
        { value: '1', label: 'Expense' }
    ]
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    return (
        <>
               {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle" >
                        {/* {t('Attachment Archive')} */}
                        {getValueFromResource('Attachment Archive',dispatch, t)}

                        </h3>
                    <div className="card-toolbar">
                        
                    </div>
                </div>
                {IsList &&
                <div className="card-body">
                    <div className="table-responsive">
                    <AttachmentArchivesItem t={t} ModuleArray={ModuleArray} IsEdit={IsEdit} />
                    </div>
                </div>
                }
            </div>
        </>
    )


}